var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.659,
    height: 62.831,
    viewBox: "0 0 114.659 62.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-time",
    transform: "translate(-125.67 -87.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13920",
    "data-name": "Group 13920",
    transform: "translate(120.274 70.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11099",
    "data-name": "Path 11099",
    d: "M118.907,46.827c-1.021-1.2-25.413-29.452-56.181-29.452S7.566,45.624,6.545,46.827a2.269,2.269,0,0,0,0,2.95c1.021,1.2,25.413,29.429,56.181,29.429s55.16-28.227,56.181-29.429A2.269,2.269,0,0,0,118.907,46.827Z",
    transform: "translate(0)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11100",
    "data-name": "Path 11100",
    d: "M42.777,63.828A21.057,21.057,0,1,1,63.81,42.794,21.067,21.067,0,0,1,42.777,63.828Z",
    transform: "translate(19.949 5.508)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11127",
    "data-name": "Path 11127",
    d: "M35.7,49.672A13.979,13.979,0,1,1,49.662,35.709,13.986,13.986,0,0,1,35.7,49.672Z",
    transform: "translate(27.023 12.585)",
    fill: "var(--secondaryColor)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11265",
    "data-name": "Path 11265",
    d: "M689.9,266.77v2.83H675.62V255.31h2.82v11.46Z",
    transform: "translate(-495.9 -146.092)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeTime);
export default __webpack_public_path__ + "static/media/eye-time.21d85b541d139cb94e298e3eea372e9e.svg";
export { ForwardRef as ReactComponent };